export const formatShareDate = (shareDate) => {
  if (shareDate) {
    const jsDate = new Date(shareDate * 1000);
    return jsDate ? jsDate.toISOString() : null;
  }
  return null;
};
